export const Overlay = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`absolute inset-0 bg-black opacity-30 ${className}`} />
  );
};
